import { ChevronDown } from "lucide-react";
import { Button } from "src/components/shadcn";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/components/shadcn";
import { useState } from "react";
import { usePulse, pulseClassName } from "src/hooks/usePulse";

export enum EnumActionType {
  CombineLists = 'combineLists',
  Export = 'export',
  Print = 'print',
  SendCard = 'sendCard',
  CloneList = 'cloneList',
  ExpiredUpload = 'expiredUpload',
  SyncToPartner = 'syncToPartner',
  SyncToAllPartners = 'syncToAllPartners',
}

export type MenuItem = {
  type: EnumActionType;
  icon: React.ReactNode;
  label: string;
  disabled?: boolean;
  onAction: () => void;
};

export const ActionsMenu = ({
  menuItems,
  triggerPulse = false,
}: {
  menuItems: MenuItem[];
  triggerPulse?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const isPulsing = usePulse(triggerPulse);

  const handleAction = (item: MenuItem) => {
    item.onAction();
    setOpen(false);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <div className={`relative ${pulseClassName(isPulsing)}`}>
          <Button variant="outline" size="sm" className="gap-2">
            Actions
            <ChevronDown className="h-4 w-4" />
          </Button>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-48">
        {menuItems.map((item) => (
          <DropdownMenuItem
            key={`${item.type}-${item.label}`}
            className="gap-3 cursor-pointer whitespace-nowrap"
            disabled={item.disabled}
            onClick={() => handleAction(item)}
          >
            {item.icon}
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
